import { RoomSideBarTabs } from "../designEnums";
import { z } from "zod";
import { ZRoomColoringId } from "./roomColoring.schema";
export const ZViewerIfcClass = z.object({
    ifcClass: z.string().min(1),
    opacity: z.number().min(0).max(1),
});
/** Matches the viewer's two alternative component filtering modes. */
export const ZViewerVisibility = z.discriminatedUnion("mode", [
    z.object({
        mode: z.literal("INSTANCE_CLASS"),
        // Complete selection: omitted classes are hidden; [] hides all classes.
        ifcClasses: z.array(ZViewerIfcClass),
    }),
    z.object({
        mode: z.literal("DISCIPLINE"),
        // Complete selection: omitted disciplines are hidden; [] hides all disciplines.
        disciplines: z.array(z.string().min(1)),
    }),
]);
export const ZViewerTableFilter = z.object({ search: z.string(), onlyDeviations: z.boolean() });
export const ZOccurrenceValidationViewSettings = z.object({
    filterMode: z.enum(["listType", "responsibility"]),
    listType: z.string().nullable(),
    responsibility: z.string().nullable(),
    tableFilter: ZViewerTableFilter,
});
export const ZStandardRoomValidationViewSettings = z.object({
    discipline: z.enum(["E", "V"]).nullable(),
    tableFilter: ZViewerTableFilter,
});
export const ZRoomValidationViewSettings = z.object({
    occurrences: ZOccurrenceValidationViewSettings,
    standardRoom: ZStandardRoomValidationViewSettings,
});
export const DEFAULT_ROOM_VALIDATION_VIEW_SETTINGS = {
    occurrences: {
        filterMode: "listType", listType: null, responsibility: null,
        tableFilter: { search: "", onlyDeviations: false },
    },
    standardRoom: {
        discipline: null,
        tableFilter: { search: "", onlyDeviations: false },
    },
};
/** Module ownership groups settings; it does not restrict where they can be applied. */
export const ZViewerModuleSettings = z.object({
    ROOM_VALIDATION: ZRoomValidationViewSettings,
});
export const getViewerComponentOpacity = (classes, instanceClass) => classes.find(entry => entry.ifcClass === instanceClass)?.opacity ?? 1;
/** Reusable display settings, independent of active module, floor, camera and selection.
 * Applying a view replaces its visibility selection rather than merging it.
 * Visibility, coloring, room panel and all module settings are restored together.
 */
export const ZViewerView = z.object({
    schemaVersion: z.literal(1),
    visibility: ZViewerVisibility,
    componentColorMode: z.enum(["SYSTEM_AND_CLASS", "MULTIPLACER_COLORS", "MMI", "DISCIPLINE_COLORS", "PRIMARY_SYSTEM"]),
    articleColoringId: z.string().min(1).nullable(),
    // Null explicitly disables room coloring. IDs also support project-defined filters.
    roomColoringId: ZRoomColoringId.nullable(),
    // Null uses the application's default panel selection.
    roomPanelTab: z.nativeEnum(RoomSideBarTabs).nullable(),
    modules: ZViewerModuleSettings,
});
